import React, { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { Colors } from "../../../../Constants/colors";
import { FontFamily } from "../../../../Constants/Enums/FontFamily.enums";

interface Props {
  value: string;
  options: string[];
  disabled?: boolean;
  onChange: (value: string) => unknown;
}

const ChevronDownIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 9l6 6 6-6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GradeDropdownCell = ({
  value,
  options,
  disabled = false,
  onChange,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) return;
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleSelect = (grade: string) => {
    onChange(grade);
    handleClose();
  };

  return (
    <>
      <button
        type="button"
        className={`rs-grade-btn${disabled ? " rs-grade-btn-disabled" : ""}`}
        onClick={handleOpen}
        disabled={disabled}
      >
        <span className="rs-grade-value">{value || "Select"}</span>
        <ChevronDownIcon />
      </button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        MenuListProps={{ dense: true }}
      >
        {options.map((grade) => (
          <MenuItem
            key={grade}
            selected={grade === value}
            onClick={() => handleSelect(grade)}
            sx={{
              fontFamily: FontFamily.ROBOTO_REGULAR,
              fontSize: "13px",
              minWidth: "90px",
              justifyContent: "center",
              "&.Mui-selected": {
                backgroundColor: `${Colors.TangerineOrange}20`,
                fontWeight: 600,
              },
            }}
          >
            {grade}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
